import { ApiRequest } from "src/helpers";
import { API_END_POINTS } from "src/constants";

export function getRiskProfiles() {
  return ApiRequest.fetchAdmin({
    method: "get",
    url: `${API_END_POINTS.RISK_PROFILES}`,
  }).then((response) => response.data.riskProfiles);
}